<template>
<!--    職員-->
    <div>
        <div :class="{'blur':addFlag}">
            <vs-row vs-type="flex" vs-align="center">
                <vs-col vs-w="6">
                    <span :class="isMobile() ? 'titleMob' : 'title'">{{$t('message.staff')}}</span>
                </vs-col>
                <vs-col vs-w="6" vs-type="flex" vs-justify="flex-end">
                    <vs-button size="small" color="rgb(37, 105, 193)" type="border" style="border-radius: 15px;" @click="createUser()">
                        + {{$t('message.addUser')}}
                    </vs-button>
                </vs-col>
            </vs-row>
            <vs-table :data="user" stripe pagination maxItems="15">
                <template slot="thead">
                    <vs-th>
                        {{$t('message.agentNo')}}
                    </vs-th>
                    <vs-th>
                        {{$t('message.username')}}
                    </vs-th>
                    <vs-th>
                        {{$t('message.email')}}
                    </vs-th>
                    <vs-th>
                        {{$t('message.phone')}}
                    </vs-th>
                    <vs-th>
                        {{$t('message.role')}}
                    </vs-th>
                    <vs-th>
                        {{$t('message.createdAt')}}
                    </vs-th>
                    <vs-th></vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                        <vs-td :data="data[indextr].agentNumber">
                            {{data[indextr].agentNumber}}
                        </vs-td>
                        <vs-td :data="data[indextr].username">
                            {{data[indextr].username}}
                        </vs-td>
                        <vs-td :data="data[indextr].email">
                            {{data[indextr].email}}
                        </vs-td>

                        <vs-td :data="data[indextr].phone">
                            {{data[indextr].phone}}
                        </vs-td>
                        <vs-td :data="data[indextr].role">
                            <span class="tags Bg1" v-if="tr.role == 'admin'">Admin</span>
                            <span class="tags Bg2" v-if="tr.role == 'agent'">Agent</span>
                            <span class="tags Bg3" v-if="tr.role == 'manager'">Manager</span>
                        </vs-td>
                        <vs-td :data="data[indextr].createdAt">
                            {{data[indextr].createdAt | dateFormat}}
                        </vs-td>
                        <vs-td>
                            <vs-button size="small" @click="editUser(tr)">{{$t('message.edit')}}</vs-button>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </div>

        <vs-popup :active.sync="addFlag" title=" ">
            <div class="card-title">
                {{$t('message.newUser')}}
            </div>
            <vs-row class="m-t-15">
                <vs-col vs-w="6">
                    <vs-input v-model="currentUser.username" :placeholder="$t('message.username')"  style="width: 100%"></vs-input>
                </vs-col>
                <vs-col vs-w="6">
                    <vs-input v-model="currentUser.password" type="password" :placeholder="$t('message.password')" style="width: 100%"></vs-input>
                </vs-col>
            </vs-row>
            <vs-row class="m-t-15">
                <vs-col vs-w="6">
                    <vs-input v-model="currentUser.name" :placeholder="$t('message.name')" style="width: 100%"></vs-input>
                </vs-col>
                <vs-col vs-w="6">
                    <vs-input v-model="currentUser.agentNumber" :placeholder="$t('message.agentNumber')" style="width: 100%"></vs-input>
                </vs-col>
            </vs-row>
            <vs-row class="m-t-15">
                <vs-col vs-w="6">
                    <vs-input v-model="currentUser.email" :placeholder="$t('message.email')" style="width: 100%"></vs-input>
                </vs-col>
                <vs-col vs-w="6">
                    <vs-input v-model="currentUser.phone" :placeholder="$t('message.phone')" style="width: 100%"></vs-input>
                </vs-col>
            </vs-row>
            <vs-row class="m-t-15" v-if="addFlag">
                <vs-col vs-w="6">
                    <vs-select v-model="currentUser.role" autocomplete :placeholder="$t('message.role')" style="width: 100%" v-role="['admin']">
                        <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in roleOpt" />
                    </vs-select>
                    <vs-select v-model="currentUser.role" autocomplete :placeholder="$t('message.role')" style="width: 100%" v-role="['manager']">
                        <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in roleOpt2" />
                    </vs-select>
                </vs-col>
            </vs-row>
            <vs-row class="m-t-3">
                <vs-col vs-w="12" vs-type="flex" vs-justify="center">
                    <vs-button size="small" color="rgb(37, 105, 193)" class="stribtn" @click="onCreateUser()">{{$t('message.add')}}</vs-button>
                </vs-col>
            </vs-row>
        </vs-popup>
        <vs-popup :active.sync="updateFlag" title=" ">
            <div class="card-title">
                {{$t('message.updateUser')}}
            </div>
            <vs-row class="m-t-15">
                <vs-col vs-w="6">
                    <vs-input v-model="currentUser.username" :placeholder="$t('message.username')"  style="width: 100%"></vs-input>
                </vs-col>
                <vs-col vs-w="6">
                    <vs-input v-model="currentUser.password" type="password" :placeholder="$t('message.password')" style="width: 100%"></vs-input>
                </vs-col>
            </vs-row>
            <vs-row class="m-t-15">
                <vs-col vs-w="6">
                    <vs-input v-model="currentUser.name" :placeholder="$t('message.name')" style="width: 100%"></vs-input>
                </vs-col>
                <vs-col vs-w="6">
                    <vs-input v-model="currentUser.agentNumber" :placeholder="$t('message.agentNumber')" style="width: 100%"></vs-input>
                </vs-col>
            </vs-row>
            <vs-row class="m-t-15">
                <vs-col vs-w="6">
                    <vs-input v-model="currentUser.email" :placeholder="$t('message.email')" style="width: 100%"></vs-input>
                </vs-col>
                <vs-col vs-w="6">
                    <vs-input v-model="currentUser.phone" :placeholder="$t('message.phone')" style="width: 100%"></vs-input>
                </vs-col>
            </vs-row>
            <vs-row class="m-t-3">
                <vs-col vs-w="12" vs-type="flex" vs-justify="center">
                    <vs-button size="small" color="rgb(37, 105, 193)" class="stribtn m-r-1" @click="onUpdateUser()">{{$t('message.update')}}</vs-button>
                    <vs-button v-role="['admin']" size="small" color="danger" class="stribtn" @click="onDeleteUser()">{{$t('message.delete')}}</vs-button>
                </vs-col>
            </vs-row>
        </vs-popup>

    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import moment from 'moment';

    export default {
        beforeRouteEnter(to,from,next){
            if($cookies.get('role') == 'admin' || $cookies.get('role') == 'manager'){
                next()
            }else if($cookies.get('role') == 'user'){
                next('/')
            }else if($cookies.get('role') == 'agent'){
                next('/customer')
            }
        },
        data() {
            return {
                token:'',
                format: 'dd / MM / yyyy',
                highlight: {
                    customPredictor(date) {
                        if ((date.getDate() - new Date().getDate() == 0) && (date.getMonth() - new Date().getMonth() == 0))
                            return true;
                    }
                },

                user:[],
                addFlag: false,
                updateFlag:false,
                roleOpt:[
                    {value:'admin',text:'Admin'},
                    {value:'manager',text:'Manager'},
                    {value:'agent',text:'Agent'},
                ],
                roleOpt2:[
                    {value:'agent',text:'Agent'},
                ],
                currentUser:{
                    username:'',
                    password:'',
                    name:'',
                    phone:'',
                    email:'',
                    agentNumber:'',
                    role:''
                },
            }
        },
        created() {
            this.token = this.$cookies.get('token');
            this.$vs.loading({
                type:'point'
            })

            let url = process.env.VUE_APP_API_BASEURL + '/api/user?role[]=admin&role[]=manager&role[]=agent&status=normal&access_token=' + this.$cookies.get('token');
            fetch(url).then((response)=>{
                return response.json()
            }).then((data)=>{
                this.user = data.responseDetail.data;
                if(data){
                    this.$vs.loading.close()
                }
            })

        },
        methods: {
            isMobile(){
                return screen.width < 500;
            },
            close(){
                this.addFlag = false;
                this.updateFlag = false;
            },
            onReload(){
                this.$vs.loading({
                    type:'point'
                })

                let url = process.env.VUE_APP_API_BASEURL + '/api/user?role[]=admin&role[]=manager&role[]=agent&status=normal&access_token=' + this.token;
                fetch(url).then((response)=>{
                    return response.json()
                }).then((data)=>{
                    this.user = data.responseDetail.data;
                    if(data){
                        this.$vs.loading.close()
                    }
                })
            },
            onCreateUser(){
                let url = process.env.VUE_APP_API_BASEURL + '/api/user?access_token=' + this.token;
                fetch(url, {
                    method: 'post',
                    headers: {
                        'Accept': 'application/json, text/plain, *!/!*',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        username:this.currentUser.username,
                        password:this.currentUser.password,
                        name:this.currentUser.name,
                        phone:this.currentUser.phone,
                        email:this.currentUser.email,
                        agentNumber:this.currentUser.agentNumber,
                        role:this.currentUser.role
                    })
                }).then((response) => {
                    return response.json()
                }).catch((error) => {
                    console.log(error);
                }).then((result) => {
                    if(result.responseCode === 200){
                        this.addFlag = false;
                        this.onReload();
                    }else{
                        this.$vs.notify({
                            title:'提示',
                            text: this.$t('message.errorMsg'),
                            icon: 'clear',
                            color:'danger',
                            position:'top-center',
                            time: 3000
                        });
                    }
                });
            },
            createUser(){
                this.currentUser = {
                    username:'',
                    password:'',
                    name:'',
                    phone:'',
                    email:'',
                    agentNumber:'',
                    role:''
                }
                this.addFlag = true
            },
            editUser(item){
                this.currentUser = {
                    username:'',
                    password:'',
                    name:'',
                    phone:'',
                    email:'',
                    agentNumber:'',
                    role:''
                }
                this.currentUser = Object.assign({},item);
                console.log(item)
                this.updateFlag = true;
            },
            onUpdateUser(){
                let url = process.env.VUE_APP_API_BASEURL + '/api/user/' + this.currentUser._id + '?access_token=' + this.token;
                fetch(url, {
                    method: 'post',
                    headers: {
                        'Accept': 'application/json, text/plain, *!/!*',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        username:this.currentUser.username,
                        password:this.currentUser.password,
                        name:this.currentUser.name,
                        phone:this.currentUser.phone,
                        email:this.currentUser.email,
                        agentNumber:this.currentUser.agentNumber,
                    })
                }).then((response) => {
                    return response.json()
                }).catch((error) => {
                    console.log(error);
                }).then((result) => {
                    if(result.responseCode === 200){
                        this.updateFlag = false;
                        this.onReload();
                    }else{
                        this.$vs.notify({
                            title:'提示',
                            text: this.$t('message.errorMsg'),
                            icon: 'clear',
                            color:'danger',
                            position:'top-center',
                            time: 3000
                        });
                    }
                });
            },
            onDeleteUser(){
                let url = process.env.VUE_APP_API_BASEURL + '/api/user/delete/' + this.currentUser._id + '?access_token=' + this.token;
                fetch(url, {
                    method: 'post',
                    headers: {
                        'Accept': 'application/json, text/plain, *!/!*',
                        'Content-Type': 'application/json'
                    }
                }).then((response) => {
                    return response.json()
                }).catch((error) => {
                    console.log(error);
                }).then((result) => {
                    if(result.responseCode === 200){
                        this.updateFlag = false;
                        this.onReload();
                    }else{
                        this.$vs.notify({
                            title:'提示',
                            text: this.$t('message.errorDel'),
                            icon: 'clear',
                            color:'danger',
                            position:'top-center',
                            time: 3000
                        });
                    }
                });
            }
        },
        components: {
            Datepicker
        },
        filters: {
            numberFormat: function (val) {
                return val.toLocaleString()
            },
            dateFormat:function (val) {
                return moment(val).format('DD/M/YYYY HH:mm')
            }
        }
    }
</script>
<style scoped>
    @import '../../assets/css/alert.css';
    .tags{
        background: #f3ca8e;
        padding: 5px 10px;
        border-radius: 5px;
        font-size: 10px;
    }

    .Bg1{
        background: #2569C1;
        color: white;
    }
    .Bg2{
        background: #77ccf6;
        color: white;
    }
    .Bg3{
        background: #4f88f8;
        color: white;
    }


</style>
